export default __webpack_public_path__ + "static/media/0xb9638272ad6998708de56bbc0a290a1de534a578.00f32a0c.jpg";